export class EdpUser {
    constructor(
        public uid: string,
        public edpLoginName: string,
        public sapUser: string,
        public partnerNumber: number,
        public firstname: string,
        public lastname: string,
        public email: string,
        public nif: string,
        public phone: string,
        public dateLastLogin: string,
        public facebookId: string,
        public googleId: string,
        public greetingTitleId: string,
        public greetingName: string,
        public segment: string,
        public nickname: string,
        public isImpersonate: string,
        public claims: string,
        public activeContracts: number,

        public displayName: string,
        public phoneNumber: string,
        public photoURL: string,

        public welcomeViewed: boolean,
        public edpESubscribed: boolean,
        public edpESubViewed: boolean,
        public b2bSegment: string,
        public edpECurrentPoints: string,
        public edpELevel: string,
        public edpELevelChange: number,
        public edpELevelLabel: string,
        public edpEPointsGathered: string,
        public edpESubscribedAt: string,
        public edpENextLevelLabel: string,
        public edpEScoreToNextLevel: number,
        public edpEScoreToMantainLevel: number,
        public profiles: string[],
        public edpEYearChange: number,
        public celebrationZs: number,
        public loginNr: number,
        public termsCond: boolean,
        public earlyAccess: string,
    ) {}

    public hasBusinessSegment() {
        return this.b2bSegment !== null;
    }

    public hasVirtualSun(): boolean {
        return this.profiles && this.profiles.includes("vsun");
    }

    public isCaixa?(): boolean {
        return this.profiles && this.profiles.includes("b2c_solar_caixa_es");
    }
}

export class EdpUserFactory {
    static create(user: IEdpUser) {
        return new EdpUser(
            user.firebaseId,
            user.edpLoginName,
            user.sapUser,
            user.partnerNumber,
            user.firstname,
            user.lastname,
            user.email,
            user.nif,
            user.phone,
            user.dateLastLogin,
            user.isGoogle,
            user.isGoogle,
            user.greetingTitleId,
            user.greetingName,
            user.segment,
            user.nickname,
            user.isImpersonate,
            user.claims,
            user.activeContracts,
            user.displayName,
            user.phoneNumber,
            user.photoURL,
            user.welcomeViewed,
            user.edpESubscribed,
            user.edpESubViewed,
            user.b2bSegment,
            user.edpECurrentPoints,
            user.edpELevel,
            user.edpELevelChange,
            user.edpELevelLabel,
            user.edpEPointsGathered,
            user.edpESubscribedAt,
            user.edpENextLevelLabel,
            user.edpEScoreToNextLevel,
            user.edpEScoreToMantainLevel,
            user.profiles,
            user.edpEYearChange,
            user.celebrationZs,
            user.loginNr,
            user.termsCond,
            user.earlyAccess
        );
    }
}

export interface IEdpUser {
    edpLoginName: string;
    sapUser: string;
    partnerNumber: number;
    firstname: string;
    lastname: string;
    email: string;
    nif: string;
    phone: string;
    dateLastLogin: string;
    profilePhotoResourceAcronym: string;
    isFacebook: string;
    isGoogle: string;
    greetingTitleId: string;
    greetingName: string;
    segment: string;
    b2bSegment?: string;
    nickname: string;
    isImpersonate: string;
    impersonateTypes: string;
    idEncrypted: string;
    firebaseId: string;
    isEdponlineUser: string;
    claims: string;
    activeContracts: number;
    profiles: string[];

    displayName?: string;
    phoneNumber?: string;
    photoURL?: string;
    welcomeViewed?: boolean;
    edpESubscribed?: boolean;
    edpESubViewed?: boolean;
    edpECurrentPoints: string;
    edpELevel: string;
    edpELevelChange: number;
    edpELevelLabel: string;
    edpEPointsGathered: string;
    edpESubscribedAt: string;
    edpENextLevelLabel: string;
    edpEScoreToNextLevel: number;
    edpEScoreToMantainLevel: number;
    edpEYearChange: number;

    celebrationZs: number;
    loginNr: number;
    termsCond: boolean;
    earlyAccess: string;
}
